import React, { useCallback } from 'react';

import { useDispatch } from 'react-redux';
import * as chatActions from 'modules/chat';



const ChannelInfo = ({ activeChannel }) => {
  const { room_id, room_name, owner_name, user_count } = activeChannel;
  const dispatch = useDispatch();

  const handleGoHome = useCallback(() => {
    dispatch(chatActions.goDefaultChannel())
  }, [dispatch]);

  return (
    <div className="sectionHeader">
      { !room_id ? 
      (<h2>실시간 이슈</h2>) :
      (
        <>
          <div className="location"><span onClick={handleGoHome} style={{cursor: 'pointer'}}>실시간 이슈</span> <strong>{room_name}</strong></div>
          <div className="roomInfo">
            <p><strong>방장</strong> {owner_name}</p>
            <p><strong>참가자</strong> {Number(user_count || 0).toLocaleString('ko-KR')}</p>
          </div>
        </>
      )}
    </div>
  )
}


export default React.memo(ChannelInfo);